'use client'

import React from 'react';
import '@/components/styles/loader-overlay.scss';

type LoaderOverlayProps = {
    visible: boolean
};

export default function LoaderOverlay({ visible }: LoaderOverlayProps) {
    if (!visible) return null;

    return (
        <div className="LoaderOverlay" role="status" aria-live="polite" aria-busy="true">
            <div className="spinner" aria-hidden="true" />
        </div>
    );
}


